import { Check } from "lucide-react";

export const DoneStep = ({ closeSelector }) => (
  <div className="flex flex-col items-center py-10 text-center" data-testid="inquiry-success">
    <span className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-600 text-white">
      <Check className="h-8 w-8" />
    </span>
    <h2 className="mt-6 font-heading text-3xl font-extrabold tracking-tight text-slate-900">
      Thank you — we've got it.
    </h2>
    <p className="mt-3 max-w-md text-slate-600">
      Your request is with the SCC team. We'll review the details and reply with deliberate next steps.
    </p>
    <button onClick={closeSelector} data-testid="path-selector-done"
      className="mt-8 rounded-full bg-primary px-8 py-3.5 font-medium text-primary-foreground transition-colors hover:bg-blue-700">
      Done
    </button>
  </div>
);